import { useTranslation } from 'react-i18next'

import { PrimeIcons } from 'primereact/api'
import { Button } from 'primereact/button'

type GenerateBoButtonProps = {
  onRequestGenerateBo: () => Promise<void>
  canGenerate: boolean
  isRequestRunning: boolean
}

const GenerateBoButton: React.FC<GenerateBoButtonProps> = ({
  onRequestGenerateBo,
  canGenerate,
  isRequestRunning,
}) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={e => onRequestGenerateBo()}
      icon={
        isRequestRunning ? `${PrimeIcons.SPINNER} pi-spin` : PrimeIcons.PLUS
      }
      label={t('trial.generatebo.labels.generateButton')}
      disabled={isRequestRunning || !canGenerate}
    />
  )
}

export default GenerateBoButton
